import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {
    GamePlayPcHeaderBarTopLeftStartSectionBox
} from "../../boxes/sections/top-section/left/game-play-pc-header-bar-top-left-start-section.box";
import {GamePcHeaderBarClockComponent} from "../../../../common/parts/clock/game-pc-header-bar-clock.component";
import {
    InGameUserSessionTimerComponent,
    InGameUserSessionTimerPipeSeparatorRenderPosition
} from "../../../../../../clock-and-last-login-box/session-timer/in-game/in-game-user-session-timer.component";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {
    GamePlayPcHeaderBarTopLeftSectionComponent
} from "../../parts/sections/top-section/left/game-play-pc-header-bar-top-left-section.component";
import {GamePlayPcHeaderBarComponent} from "../../game-play-pc-header-bar.component";
import {
    SwedenResponsibleGamingButtonsComponent
} from "../../../../../../responsible-gambling/responsible-gaming-buttons/regulations/sweden/sweden.responsible-gaming-buttons.component";
import {BottomSectionBox} from "./boxes/bottom-section.box";
import {
    SwedenMinimumGamblingAgeComponent
} from "../../../../../../responsible-gambling/minimum-gambling-age/regulations/sweden/sweden.minimum-gambling-age.component";

export const SwedenGamePlayPcHeaderBarComponent = observer(
    class SwedenGamePlayPcHeaderBarComponent extends OrbitComponent<{gameContext: IGameContextViewModel}> {
        private _renderTopLeftStartSection = () => {
            return (
                <GamePlayPcHeaderBarTopLeftStartSectionBox>
                    <GamePcHeaderBarClockComponent/>
                    <InGameUserSessionTimerComponent pipeSeparatorPosition={InGameUserSessionTimerPipeSeparatorRenderPosition.Before}/>
                    <BlankHorizontalSeparatorBox/>

                </GamePlayPcHeaderBarTopLeftStartSectionBox>
            )
        }

        private _renderBottomSection = () => {
            return (
                <BottomSectionBox>
                    <BlankHorizontalSeparatorBox multiplier={2}/>
                    <SwedenMinimumGamblingAgeComponent/>
                    <BlankHorizontalSeparatorBox/>
                    <SwedenResponsibleGamingButtonsComponent useIconsOnly={false}/>
                </BottomSectionBox>

            );
        }

        private _renderTopLeftSection = () => {
            return (
                <GamePlayPcHeaderBarTopLeftSectionComponent gameContext={this.props.gameContext}
                                                            renderStartSection={this._renderTopLeftStartSection}/>
            )
        }

        private _getTopMiddleSectionRenderer = () => {
            if(this.props.gameContext.freePlayContext.isFreePlay) {
                return undefined;
            }

            return undefined;
        }

        render() {
            return (
                <GamePlayPcHeaderBarComponent gameContext={this.props.gameContext}
                                              renderTopLeftSection={this._renderTopLeftSection}
                                              renderTopMiddleSection={this._getTopMiddleSectionRenderer()}
                                              renderBottomSection={this._renderBottomSection}/>
            )
        }
    }
);